'use client';

import { tv } from 'tailwind-variants';

import { SearchInput } from './search-input.component';

import { handleOpenSearchModal } from '@/store/search/handle-open-search-modal';

export enum ProgressiveSearchModalKeys {
  SEARCH = 'SEARCH',
  ASK_ADD_MORE_EXAMS = 'ASK_ADD_MORE_EXAMS',
  SELECT_MORE_EXAMS = 'SELECT_MORE_EXAMS',
  ATTENTION_TO_LOSE_LABORATORY_PROCEDURE = 'ATTENTION_TO_LOSE_LABORATORY_PROCEDURE',
  SELECTED_OVERVIEW_EXAMS = 'SELECTED_OVERVIEW_EXAMS',
}

const searchStyle = tv({
  slots: {
    container: 'z-30 sticky top-0 bg-white',
  },
});

export interface SelectedProcedures {
  id: string;
  code: string;
  displayName: string;
  examOrVaccineGroup?: SelectedProcedures[];
}

function SearchTrigger({ children }: { children?: React.ReactNode }) {
  if (!children) {
    return <SearchInput className="border-green-200" />;
  }

  return children;
}

interface SearchProps {
  className?: string;
  styleType?: 'sticky' | 'flat';
  children?: React.ReactNode;
  triggerClassName?: string;
  disableRenderInputWithModal?: boolean;
}

export function Search({
  className,
  triggerClassName,
  children,
  styleType = 'sticky',
}: SearchProps) {
  const { container } = searchStyle();

  if (styleType === 'flat') {
    return (
      <div
        onClick={() => {
          handleOpenSearchModal();
        }}
        data-testid="search-section"
        className={triggerClassName}
      >
        {children || <SearchTrigger />}
      </div>
    );
  }

  return (
    <div id="home-search-bar" className={container({ className })} data-testid="search-section">
      <section className="px-5 py-3 hidden">
        <div className="z-30 sticky top-14">
          <SearchInput />
        </div>
      </section>
    </div>
  );
}

Search.Trigger = SearchTrigger;
